import React from 'react';
import PropTypes from 'prop-types';
import BarberHoverMenuTimeTrackingToggleButton from '../containers/BarberHoverMenuTimeTrackingToggleButton';

const BarberHoverMenuTimeTracking = ({ clockedTime, barberId }) => (
  <div className="u-text-center u-p0 u-flex u-justify-content-space-between u-align-items-center">
    <BarberHoverMenuTimeTrackingToggleButton barberId={barberId} />
    <span className="u-flex u-ml-" style={{ lineHeight: '48px', flexShrink: 0 }}>{clockedTime}</span>
  </div>
);
BarberHoverMenuTimeTracking.propTypes = {
  clockedTime: PropTypes.string.isRequired,
  barberId: PropTypes.string.isRequired,
};

export default BarberHoverMenuTimeTracking;
